import request from "../../../helpers/request";

export const putAlertasPlanoDeAcao = async ({
  id,
  causa,
  planoAcao,
  previsao,
}) => {
  if (!id) return null;
  const url = `${process.env.REACT_APP_API}/Alerta/PlanoAcao/${id}?causa=${causa}&planoAcao=${planoAcao}&previsao=${previsao}`;
  const result = await request({ url, method: "put" });
  return result.data;
};
